import React from 'react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Paper,
  MenuItem,
  TextField,
  InputAdornment,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Radio,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import CustomFooter from '../../../../components/Table/CustomFooter';

class RouterView extends React.PureComponent {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    const { classes, t } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle className='header' id='form-dialog-title' style={{ padding: '16px 24px 0px' }}>
          {t('select_router')}
          <label className='badge badge-base'>
            {this.props.count} {t('routers')}
          </label>
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden', padding: 0 }}>
          <Grid container spacing={16} style={{ padding: '8px 20px' }}>
            <Grid item sm={6} xs={12}>
              <TextField
                select
                id='select'
                name='select'
                variant='outlined'
                margin='dense'
                value={this.props.category || 0}
                onChange={(e) => this.props.handleSelect(e)}
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
                style={{
                  width: '100%',
                }}
              >
                <MenuItem value={0}>{t('select_router')}</MenuItem>
                {this.props.categories.map((data, i) => (
                  <MenuItem key={i} id={data.category} value={data.category}>
                    {data.category}
                  </MenuItem>
                ))}
                <MenuItem value='all'>{t('select_all')}</MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                required
                id='search'
                name='search'
                fullWidth
                value={this.props.search || ''}
                onChange={(e) => this.props.handleSearch('search', e.target.value)}
                variant='outlined'
                margin='dense'
                placeholder={t('wizard_search_router')}
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                  startAdornment: (
                    <InputAdornment position='start'>
                      {' '}
                      <svg width='24' height='24' viewBox='0 0 24 24'>
                        <use xlinkHref={`/images/menus-v1.svg#search`} />
                      </svg>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Paper className={classes.paperTable}>
            <div style={{ overflow: 'auto', maxHeight: '320px' }}>
              <Table>
                <TableHead>
                  <TableRow style={{ border: 'none', height: 35 }}>
                    <CustomTableCell style={{ paddingLeft: 60 }}>{t('wizard_router_name')}</CustomTableCell>
                    <CustomTableCell>{t('wizard_router_serail')}</CustomTableCell>
                    <CustomTableCell>{t('wizard_router_type')}</CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(this.props.routerList.data || []).map((router, i) => (
                    <TableRow key={i}>
                      <CustomTableCell
                        component='th'
                        scope='row'
                        // style={{ width: 80 }}
                      >
                        <Grid
                          container
                          alignItems='center'
                          className={router.mapId ? classes.textDisable : classes.textColor}
                        >
                          <Radio
                            id={`radio-${router.id}`}
                            checked={this.props.routerPoint.id === router.id}
                            value={router.id}
                            name='routerId'
                            color='primary'
                            onChange={(e) => {
                              this.props.handleChange(e);
                            }}
                            disabled={router.mapId ? true : false}
                          />
                          {router.place || router.name}
                        </Grid>
                      </CustomTableCell>
                      <CustomTableCell
                        component='th'
                        scope='row'
                        className={router.mapId ? classes.textDisable : classes.textColor}
                      >
                        {router.serial}
                      </CustomTableCell>
                      <CustomTableCell component='th' scope='row'>
                        <label
                          className={`badge ${
                            router.mapId
                              ? 'badge-disabled'
                              : router.type && router.type.category === 'MOKO GATEWAY'
                                ? 'badge-wizard-primary'
                                : router.type && router.type.category === 'RASPBERRY PI'
                                  ? 'badge-wizard-info'
                                  : 'badge-wizard-indigo'
                          }`}
                        >
                          <span className='dot' />
                          {router.type && router.type.name}
                        </label>
                      </CustomTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
          <Grid container style={{ position: 'relative', marginBottom: 40 }}>
            <div style={{ position: 'absolute', right: '-30px' }}>
              <CustomFooter
                count={this.props.count}
                page={this.props.page}
                rowsPerPage={this.props.limit}
                rowsPerPageOptions={[]}
                changePage={this.props.changePage}
              />
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container style={{ padding: 20, justifyContent: 'space-between' }}>
            {/* <div className={classes.buttons}> */}
            <Button
              id='cancel'
              variant='outlined'
              color='primary'
              className={classes.button}
              onClick={this.props.handleClose}
            >
              {t('cancel')}
            </Button>
            {this.props.devices &&
            this.props.devices.data &&
            this.props.devices.data.length === 0 &&
            this.props.search === null ? (
              ''
            ) : (
              <Button
                id='add'
                variant='contained'
                onClick={this.props.handleSubmit}
                color='primary'
                className={classes.button}
                disabled={!this.props.disable}
              >
                {t('add')}
              </Button>
            )}
            {/* </div> */}
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F9FAFB',
    color: '#667085',
    border: 'none',
    fontSize: 12,
    fontWeight: 500,
    borderTop: '1px solid #EAECF0',
    borderBottom: '1px solid #EAECF0',
    padding: '4px 20px 4px 12px',
  },
  body: {
    fontSize: 14,
    borderTop: '1px solid #EAECF0',
    borderBottom: 'none',
    padding: '4px 20px 4px 12px',
  },
}))(TableCell);

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  textColor: {
    color: theme.palette.text.primary,
  },
  textDisable: {
    color: theme.palette.text.hint,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    // marginLeft: theme.spacing.unit * 1,
    width: 100,
    borderRadius: '4px',
  },
  divider: {
    marginTop: '20px',
  },
  tableCellRadio: {
    width: '50px',
    padding: 4,
  },
  paperTable: {
    boxShadow: 'none',
    borderBottom: '1px solid #EAECF0',
  },
});

export const translation = withTranslation()(RouterView);
export default withStyles(styles, { withTheme: true })(translation);
